import { createAction } from '@reduxjs/toolkit';

import type { SendHelpEmailRequest } from './types';

export const sendHelpEmailRequest = createAction<SendHelpEmailRequest>('sendHelpEmail/request');
